import React, { useState } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const QuoteIcon = () => (
    <svg className="absolute -top-4 -left-6 w-20 h-20 text-pink-500" viewBox="0 0 78 60" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.51109 59.5344C8.8275 59.9921 7.11148 60.3949 6.10763 59.2923L4.25537 56.9879C3.35958 55.4895 4.44447 54.0999 5.14685 53.5236C8.4861 50.7835 10.9143 48.6639 12.4294 47.1647C15.4007 44.0737 17.5971 40.9796 19.0472 37.8949C19.3789 37.1896 18.5324 36.7419 18.0927 36.5994C7.1432 33.0495 1.66667 26.7912 1.66667 17.8258C1.66667 12.5436 3.44024 8.25123 6.98541 4.95151C10.5322 1.64986 14.9751 0 20.313 0C25.0684 0 29.2823 2.1452 32.9523 6.43716C36.5406 10.4797 38.3333 14.8549 38.3333 19.559C38.3337 33.3454 28.7267 46.6701 9.51109 59.5344ZM49.5107 59.5344C48.8271 59.9921 47.1111 60.3949 46.1072 59.2923L44.255 56.9879C43.3592 55.4895 44.4441 54.0999 45.1465 53.5236C48.4853 50.7835 50.9139 48.6639 52.4291 47.1647C55.4003 44.0737 57.5967 40.9796 59.0472 37.8949C59.3789 37.1896 58.5324 36.7419 58.0927 36.5994C47.1432 33.0495 41.6667 26.7912 41.6667 17.8258C41.6667 12.5436 43.4402 8.25123 46.9854 4.95151C50.5326 1.64986 54.9751 0 60.313 0C65.0684 0 69.2823 2.1452 72.9523 6.43716C76.5402 10.4797 78.3333 14.8549 78.3333 19.559C78.3333 33.3454 68.7263 46.6701 49.5107 59.5344Z" transform="translate(0 10) rotate(-180 40 30)"/>
    </svg>
);

const testimonials = [
  {
    quote: "It's a very good platform that you have which is specifically for women! I just hope that more women know you are doing such a great thing for them. To be able to come out and specifically be so deeply believe in doing something for women and creating this platform is definitely such a great act on your part. I just hope th...",
    name: 'Bee Kheng Tay, Cisco',
    title: 'Managing Director, Singapore and Brunei at Cisco',
    avatar: 'https://www.halftheskyasia.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBNWRWRmc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--a6fa4e2a84451025e0184905910c369b7f935a2e/BK.png?disposition=attachment'
  },
  {
    quote: "I love it! Your platform gives the transparency of workplace policies and support to women especially. Also, instead of companies screening candidates, now female candidates can screen these companies and I think that's a really powerful thing!",
    name: 'Uma Thana, VMware',
    title: 'Vice President & Channel Chief, Asia Pacific & Japan',
    avatar: 'https://www.halftheskyasia.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBNWxWRmc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--7040045071e1c97a6a4d957f27697c63bd1c4f18/Uma%202.png?disposition=attachment'
  },
  {
    quote: "It is absolutely an amazing and brilliant initiative! We do need such initiative to instill that confidence and the mind of women that we can do anything that we want.",
    name: 'Rachna Sampayo, Oracle',
    title: "Vice President Human Resources, ASEAN & SAGE at Oracle",
    avatar: 'https://www.halftheskyasia.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBNU5WRmc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--510b6decf45f91a82c765943464173bc413d34bc/Rachna.png?disposition=attachment'
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const [imageErrors, setImageErrors] = useState({});

  const handlePrev = () => {
    setCurrent(current === 0 ? testimonials.length - 1 : current - 1);
  };
  const handleNext = () => {
    setCurrent(current === testimonials.length - 1 ? 0 : current + 1);
  };

  const handleImageError = (index) => {
    setImageErrors(prev => ({ ...prev, [index]: true }));
  };

  const { quote, name, title, avatar } = testimonials[current];
  const hasImageError = imageErrors[current];
  // Placeholder avatar if image fails to load
  const avatarSrc = hasImageError 
    ? 'https://ui-avatars.com/api/?name=' + encodeURIComponent(name) + '&background=random'
    : avatar;

  return (
    <section className="bg-white py-20 sm:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* Image */}
          <div className="relative flex-shrink-0 w-48 h-48">
              <QuoteIcon />
              <img 
                className="w-full h-full rounded-full object-cover shadow-lg" 
                src={avatarSrc} 
                alt={name}
                onError={() => handleImageError(current)}
              />
          </div>
          {/* Text */}
          <div className="flex-grow text-center md:text-left">
              <p className="text-xl text-gray-700 leading-relaxed mb-6">{quote}</p>
              <h5 className="font-bold text-lg text-purple-800">{name}</h5>
              <p className="text-gray-500">{title}</p>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex justify-center items-center mt-12 gap-4">
            <button onClick={handlePrev} className="text-gray-400 hover:text-gray-600 transition-colors">
                <FaArrowLeft size={20} />
            </button>
            <div className="flex gap-2">
                {testimonials.map((_, i) => (
                    <div
                        key={i}
                        className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${current === i ? 'bg-pink-500 w-6' : 'bg-gray-300'}`}
                    />
                ))}
            </div>
            <button onClick={handleNext} className="text-gray-400 hover:text-gray-600 transition-colors">
                <FaArrowRight size={20} />
            </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 